// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function make(parkingInfoEnabled, parkingSpaces, parkingDetails) {
  let parkingSpots = parkingInfoEnabled ? Stdlib_Option.map(parkingSpaces, parkingSpaces => parkingSpaces.toString()) : undefined;
  let parkingDetails$1;
  if (parkingInfoEnabled) {
    let parkingDetails$2 = Stdlib_Option.map(parkingDetails, prim => prim.trim());
    parkingDetails$1 = parkingDetails$2 !== undefined && parkingDetails$2 !== "" ? JsxRuntime.jsx("span", {
        children: parkingDetails$2,
        className: "whitespace-pre-line"
      }) : undefined;
  } else {
    parkingDetails$1 = undefined;
  }
  return {
    parkingSpots: parkingSpots,
    parkingDetails: parkingDetails$1
  };
}

let ListingDetails = {
  make: make
};

function PropertyParkingInfo$InputFields(props) {
  let onParkingDetailsBlur = props.onParkingDetailsBlur;
  let onParkingDetailsChange = props.onParkingDetailsChange;
  let onParkingSpacesBlur = props.onParkingSpacesBlur;
  let onParkingSpacesChange = props.onParkingSpacesChange;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: [
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(Form__Input.make, {
          labelText: "Parking Spaces",
          optionalText: "optional",
          onChange: event => onParkingSpacesChange(Stdlib_Int.fromString(Form__Helpers.stripNonDigits(event.target.value), undefined)),
          onBlur: param => onParkingSpacesBlur(),
          value: Stdlib_Option.mapOr(props.parkingSpaces, "", parkingSpaces => parkingSpaces.toString())
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 6,
        children: JsxRuntime.jsx(Form__TextAreaField.make, {
          labelText: "Parking Details",
          optionalText: "optional",
          placeholderText: "e.g. Assigned, deeded, heated garage, level B2",
          onChange: event => onParkingDetailsChange(Form__Helpers.noneIfEmpty(event.target.value)),
          onBlur: param => onParkingDetailsBlur(),
          value: props.parkingDetails,
          rows: 1
        })
      })
    ]
  });
}

let InputFields = {
  make: PropertyParkingInfo$InputFields
};

let Grid;

let Cell;

exports.Grid = Grid;
exports.Cell = Cell;
exports.ListingDetails = ListingDetails;
exports.InputFields = InputFields;
/* Form__Input Not a pure module */
